import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {setStationSearchTextMonitoring, stationSearchTextSelectorMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useStationSearchTextMonitoring = () => {
    const dispatch = useDispatch();
    const searchText = useSelector(stationSearchTextSelectorMonitoring);

    const onChangeSearchText = React.useCallback((text: string) => {
        dispatch(setStationSearchTextMonitoring(text));
    }, [dispatch]);
    return {
        searchText,
        onChangeSearchText,
    };
};